(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name productes.controller:ProductesCtrl
   *
   * @description
   *
   */
  angular
    .module('itecAdministracio.productes')
    .controller('ProductesCtrl', ProductesCtrl);

  function ProductesCtrl() {
    var vm = this;
    vm.ctrlName = 'ProductesCtrl';
  }
}());
